import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import styles from './DashboardHero.module.css'; // New CSS module
import { useAuth } from '../../contexts/AuthContext';
import WeatherWidget from '../widgets/WeatherWidget';

const DashboardHero = () => {
    const { user } = useAuth();


    const slides = [
        '/images/maison.jpg',
        '/images/maison2.jpg',
        '/images/maison3.jpg',
        '/images/terrasse.jpg',
        '/images/pergola.jpg'
    ];

    return (
        <div className={styles.heroContainer}>
            <Swiper
                modules={[Autoplay, EffectFade]}
                effect="fade"
                speed={2000}
                autoplay={{
                    delay: 6000,
                    disableOnInteraction: false,
                }}
                loop={true}
                className={styles.heroSwiper}
            >
                {slides.map((img, index) => (
                    <SwiperSlide key={index}>
                        <div
                            className={styles.slideBg}
                            style={{ backgroundImage: `url(${img})` }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className={styles.overlay}></div>

            <div className={styles.content}>
                <div className={styles.textContent}>
                    <h1 className={styles.greeting}>
                        <span className={styles.userName}>{user?.name?.split(' ')[0] || 'Partenaire'}</span>
                    </h1>
                    <p className={styles.subtext}>
                        Pilotage en temps réel de votre chantier. <br />
                        <strong>L'excellence Maison Quinard à portée de main.</strong>
                    </p>
                </div>

                {/* Weather widget removed */}
            </div>
        </div>
    );
};

export default DashboardHero;
